import { motion } from "framer-motion";

export const BOOKING_URL =
  "https://api.leadconnectorhq.com/widget/bookings/frefwe-61d00660-3b31-4af3-a3cc-5ddc6988517e-bbfe946f-a577-46b0-a1f5-c5dcf77a2ee5-26211ef9-6845-4eda-9c42-58fbbc99e427-49cf9121-0869-46cd-9293-fbd39a805ae5-41bda1c0-af20-4f82-9236-f083ceec9f64xwpljh";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_inbound-calls-ranked/artifacts/vqudye2p_ARCO%20LOGO%20ASSETS%20%281%29.png";

export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

export const ArcoLogo = ({ className = "", size = 32 }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="arco-logo">
    <div
      className="relative overflow-hidden shrink-0"
      style={{ width: size, height: size }}
    >
      <img
        src={LOGO_URL}
        alt="Arco Scaling"
        className="absolute inset-0 w-full h-full object-cover scale-[1.55]"
        draggable="false"
      />
    </div>
    <span className="font-display text-white font-black text-xl tracking-tight">
      Arco<span className="text-[#FF5C00]">.</span>
    </span>
  </div>
);

export const SectionHead = ({ eyebrow, title, sub, accent }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.7 }}
    className="max-w-3xl mx-auto text-center"
  >
    {eyebrow && (
      <div className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.25em] text-[#FF5C00]">
        <span className="w-1.5 h-1.5 rounded-full bg-[#FF5C00]" />
        {eyebrow}
      </div>
    )}
    <h2 className="font-display mt-4 text-white text-4xl md:text-5xl lg:text-6xl font-black tracking-tight leading-[1.02]">
      {title}
      {accent && <span className="text-[#FF5C00]"> {accent}</span>}
    </h2>
    {sub && (
      <p className="mt-5 text-white/60 text-base md:text-lg leading-relaxed">
        {sub}
      </p>
    )}
  </motion.div>
);
